import { Component, OnInit, Inject } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { IonicModule } from "@ionic/angular";
import { NgClass } from "@angular/common";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-pick-your-number",
    templateUrl: "./pick-your-number.component.html",
    styleUrls: ["./pick-your-number.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        NgClass,
        MatIcon,
    ],
})
export class PickYourNumberComponent implements OnInit {
  regularTicketNumber = [];
  specialTicketNumber = [];
  regularPickNumber = [];
  specialPickNumber = [];
  unSelectedRegularNumberIdx = [];
  unSelectedSpecialNumberIdx = [];
  regularPickNumberCount = 0;
  specialPickNumberCount = 0;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<PickYourNumberComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public ticketData: any
  ) { }

  ngOnInit() {
    this.intializeNumber();
  }

  intializeNumber() {
    for (
      let i = 0;
      i < this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.max_ball_regular;
      i++
    ) {
      let ticketNumber = {} as any;
      ticketNumber.ticket = i + 1;
      ticketNumber.isSelected = false;
      this.regularTicketNumber[i] = ticketNumber;
    }
    if (this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.count_ball_special) {
      for (
        let i = 0;
        i < this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.max_ball_special;
        i++
      ) {
        let ticketNumber = {} as any;
        ticketNumber.ticket = i + 1;
        ticketNumber.isSelected = false;
        this.specialTicketNumber[i] = ticketNumber;
      }
    }


    this.ticketData?.productDetails[this.ticketData.lotteryIndex].draw_lines[this.ticketData.lineIndex].forEach(
      (data, index) => {
        if (
          data &&
          index < this.ticketData?.productDetails[this.ticketData.lotteryIndex]?.lotteryInfo?.count_ball_regular
        ) {
          this.regularTicketNumber[data - 1].isSelected = true;
          this.regularPickNumber.push(data);
          this.regularPickNumberCount++;
        } else if (
          data &&
          index >= this.ticketData?.productDetails[this.ticketData?.lotteryIndex]?.lotteryInfo?.count_ball_regular
        ) {
          this.specialTicketNumber[data - 1].isSelected = true;
          this.specialPickNumber.push(data);
          this.specialPickNumberCount++;
        }
      }
    );
  }
  addRegularTicket(item) {
    try{
      const idx = this.regularPickNumber?.indexOf(item.ticket);
    if (item.isSelected) {
      this.unSelectedRegularNumberIdx.push(idx);
      this.regularPickNumberCount--;
      item.isSelected = !item.isSelected;
    } else if (
      this.regularPickNumberCount <
      this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.count_ball_regular &&
      this.unSelectedRegularNumberIdx?.length !== 0
    ) {
      this.regularPickNumber[this.unSelectedRegularNumberIdx[0]] = item.ticket;
      this.unSelectedRegularNumberIdx.shift();
      item.isSelected = !item.isSelected;
      this.regularPickNumberCount++;
    } else if (
      this.regularPickNumberCount <
      this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.count_ball_regular &&
      this.unSelectedRegularNumberIdx?.length === 0
    ) {
      item.isSelected = !item.isSelected;
      this.regularPickNumber.push(item.ticket);
      this.regularPickNumberCount++;
    }
    } catch(e){
    }
    
  }

  selectRegularNumber(item) {
    try{
      const idx = this.regularPickNumber?.indexOf(item.ticket);
      if (!this.ticketData?.productDetails[this.ticketData.lotteryIndex].lotteryInfo?.regular_special_duplicate) {
        if (this.specialPickNumber?.indexOf(item.ticket) === -1) {
          this.addRegularTicket(item);
        }
      } else {
        this.addRegularTicket(item);
      }
    } catch(e){

    }
   

  }

  addSpecialTicket(item) {
    try{
    const idx = this.specialPickNumber?.indexOf(item.ticket);
    if (item.isSelected) {
      this.unSelectedSpecialNumberIdx.push(idx);
      this.specialPickNumber?.splice(this.specialPickNumber?.indexOf(idx), 1);
      this.specialPickNumberCount--;
      item.isSelected = !item.isSelected;

    } else if (
      this.specialPickNumberCount <
      this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.count_ball_special &&
      this.unSelectedSpecialNumberIdx?.length !== 0
    ) {
      this.specialPickNumber[this.unSelectedSpecialNumberIdx[0]] = item.ticket;
      this.unSelectedSpecialNumberIdx.shift();
      item.isSelected = !item.isSelected;
      this.specialPickNumberCount++;
    } else if (
      this.specialPickNumberCount <
      this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.count_ball_special &&
      this.unSelectedSpecialNumberIdx?.length === 0
    ) {
      item.isSelected = !item.isSelected;
      this.specialPickNumber.push(item.ticket);
      this.specialPickNumberCount++;
    }

    } catch(e){

    }

  }

  selectSpecialTicket(item) {
    try{
      if (!this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.regular_special_duplicate) {
        if (this.regularPickNumber?.indexOf(item.ticket) === -1) {
          this.addSpecialTicket(item);
        }
      } else {
        this.addSpecialTicket(item);
      }
    } catch(e){

    }
   
  }

  autoPick() {
    this.bottomSheetRef.dismiss({ autoPick: true });
  }

  back() {
    this.bottomSheetRef.dismiss();
  }

  finishPicking() {
    this.ticketData.productDetails[this.ticketData.lotteryIndex].draw_lines[this.ticketData.lineIndex].forEach(
      (data, index) => {
        if (index < this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.count_ball_regular) {
          this.ticketData.productDetails[this.ticketData.lotteryIndex].draw_lines[this.ticketData.lineIndex][
            index
          ] = this.regularPickNumber[index];
        } else {
          this.ticketData.productDetails[this.ticketData.lotteryIndex].draw_lines[this.ticketData.lineIndex][
            index
          ] = this.specialPickNumber[
            index - this.ticketData.productDetails[this.ticketData.lotteryIndex].lotteryInfo.count_ball_regular
            ];
        }
      }
    );
    this.bottomSheetRef.dismiss({ autoPick: false, ticketData: this.ticketData });
  }
}
